import { orderBy } from "lodash";
import { Api } from "queries/types";
import { useQuery } from "react-query";
import { get } from "./http";

const useShopBrandsIndex = () =>
  useQuery<Api.ShopBrand[]>(["shop_brands"], () => get("/shop_referentials/get_brand"), {
    select: (data) => orderBy(data, "name"),
  });

export { useShopBrandsIndex };
